import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as eventsApi from "@api/events.api";
import type { Event } from "@/types";

interface EventsState {
  items: Event[];
  loading: boolean;
}

const initialState: EventsState = {
  items: [],
  loading: false,
};

export const fetchEvents = createAsyncThunk("events/fetchAll", async () => {
  return await eventsApi.getAll();
});

export const createEvent = createAsyncThunk(
  "events/create",
  async (data: {
    name: string;
    restaurantId?: string;
    startedAt: string;
    endedAt?: string;
    userIds?: string[];
  }) => {
    return await eventsApi.create(data);
  },
);

export const deleteEvent = createAsyncThunk(
  "events/delete",
  async (id: string) => {
    await eventsApi.remove(id);
    return id;
  },
);

const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchEvents.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createEvent.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })
      .addCase(deleteEvent.fulfilled, (state, action) => {
        state.items = state.items.filter((e) => e.id !== action.payload);
      });
  },
});

export default eventsSlice.reducer;
